import { ChangeEvent, useCallback } from 'react'
import styled from '@emotion/styled'
import { FusionColor } from '../../../theme/FusionStyle'
import { decodeLineBreaks, encodeLineBreaks } from '@fusion-advantage/formlib'

interface TextAreaControlProps {
	borderColor?: FusionColor
	minRows: number
}

const TextAreaControl = styled.textarea<TextAreaControlProps>(({theme, borderColor, minRows}) => ({
	alignSelf: 'stretch',
	backgroundColor: theme.colors.white,
	border: `1px solid ${borderColor ? theme.colors[borderColor] : theme.colors.lines}`,
	borderRadius: theme.borderRadius,
	padding: theme.spacing(1),
	fontSize: '1rem',
	'::placeholder': {
		color: theme.colors[FusionColor.MiniHeader]
	},
  	fieldSizing: 'content', /* Enables automatic resizing based on content */
  	minHeight: `${minRows}lh`,       /* Optional: Sets a minimum height (e.g., 1 line high) */
}))

interface L1TextAreaProps {
	autoFocus?: boolean
	value?: string
	placeholder?: string
	disabled?: boolean
	borderColor?: FusionColor
	rows?: number
	onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void,
}

const L1TextArea = ({autoFocus, value, placeholder, disabled, borderColor, rows = 6, onChange}: L1TextAreaProps) => {
	const handleChange = useCallback((e: React.ChangeEvent<HTMLTextAreaElement>) => {
		onChange({
			...e,
			target: {
				...e.target,
				value: encodeLineBreaks(e.target.value)
			},
		})
	}, [onChange])
	return (
		<TextAreaControl
			autoFocus={autoFocus}
			value={value ? decodeLineBreaks(value) : ''}
			placeholder={placeholder}
			disabled={disabled}
			borderColor={borderColor}
			minRows={rows}
			onChange={handleChange}
		/>
	)
}

export default L1TextArea
